import { FC, useEffect } from 'react';

import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import Button from 'components/Base/Button';
import LoginForm from 'components/LoginForm';
import ModalContentWindow from 'components/Modals/ModalContentWindow';
import ResetPasswordModal from 'components/Modals/ResetPasswordModal';
import { PROFILE_SECTIONS } from 'constants/UserMenu';
import useLogin from 'hooks/useLogin';
import { RootStateType } from 'store/reducers';
import { trackAmplitudeEvent } from 'utils/amplitude/amplitudeTrackingUtlis';
import { LOGOUT_EVENT } from 'utils/amplitude/amplituteConstants';

const Login: FC = () => {
  const {
    user,
    changeUserHandler,
    error,
    forgotPasswordHandler,
    onLoginUserHandler,
    isButtonClicked,
    disableLogin,
    showModal,
    setShowModal,
    showStripePaidModal,
    onCloseStripePaidModal,
    onClickStripePaidButtonHandler,
  } = useLogin();

  const userInfo = useSelector((state: RootStateType) => state.profile.profileInfo);
  const location = useLocation<{ from?: string; }>();
  const history = useHistory();

  useEffect(() => {
    if (userInfo && location.state?.from === PROFILE_SECTIONS.LOGOUT) {
      trackAmplitudeEvent({
        eventName: LOGOUT_EVENT,
        userInfo,
      });
      history.replace({ ...history.location, state: { ...(history.location.state as object), from: null } });
    }
  }, [userInfo]);

  return (
    <>
      <LoginForm
        user={user}
        changeUserHandler={changeUserHandler}
        error={error}
        forgotPasswordHandler={forgotPasswordHandler}
        onLoginUserHandler={onLoginUserHandler}
        isButtonClicked={isButtonClicked && !showStripePaidModal}
        disableLogin={disableLogin}
      />
      <ModalContentWindow
        centered
        showModal={showModal}
        onCloseModal={setShowModal}
        titleText="Reset Password"
        showDefaultText={false}
      >
        <ResetPasswordModal setShowModal={setShowModal} />
      </ModalContentWindow>
      <ModalContentWindow
        centered
        showModal={showStripePaidModal}
        onCloseModal={onCloseStripePaidModal}
        titleText="We don't want to see you go!"
        showDefaultText={false}
      >
        <div className="text-center">
          <span>
            Thank you for trialing UnicornForms, but your trial has ended. Please provide your payment information.
          </span>
        </div>
        <div className="text-center mt-4">
          <Button onClick={onClickStripePaidButtonHandler}>
            Provide payment information
          </Button>
        </div>
      </ModalContentWindow>
    </>
  );
};

export default Login;